<template>
  <section
    id="intro"
    class="text-center mb-12"
  >
    <h1 class="display-2 font-weight-light mb-8">
      All Ears Counselling Service
    </h1>
    <h2>Cheryl Forrester MSc</h2>
    <br>

    <v-responsive
      class="mx-auto subtitle-1 grey--text"
      max-width="600"
    >
      Welcome to All Ears Counselling Service, based in Rhyl, North Wales.
      I provide a cost-effective, professional counselling service focused on providing you with a safe space
      to talk about life issues that are bothering you.
    </v-responsive>

    <v-container class="pa-4 text-center">
      <v-row
        class="fill-height"
        align="center"
        justify="center"
      >
        <template v-for="(item, i) in items">
          <v-col
            :key="i"
            cols="12"
            md="4"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 12 : 1"
                :outlined="true"
                :class="{ 'on-hover': hover }"
                :href="item.link"
              >
                <v-img
                  :src="item.img"
                  height="225px"
                >
                  <v-card-title class="text-h2 black--text font-weight-bold">
                    <v-row
                      class="fill-height flex-column"
                      justify="space-between"
                    >
                      <p class="mt-4 heading text-center">
                        {{ item.title }}
                      </p>
                    </v-row>
                  </v-card-title>
                </v-img>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {
    name: 'Headline',
    data: () => ({
      items: [
        {
          title: 'About AECS',
          img: require('@/assets/sunflower.png'),
          link: '/#/about',
        },
        {
          title: 'Fees',
          img: require('@/assets/daffodils.png'),
          link: '/#/fees',
        },
        {
          title: 'Contact AECS',
          img: require('@/assets/poppies.png'),
          link: '/#/contact',
        },
      ],
      transparent: 'rgba(255, 255, 255, 0)',
    }),
  }
</script>
